/**
 * You can't request
 *
 * $scope
 * $element
 *
 * here
 */

// eslint-disable-next-line no-unused-vars
import APIV5 from '~/models/api';

/* globals Knitiv */

export class BaseController {
	/** @type {Knitiv.Angular.Q} */
	$q;

	/** @type {import('angular').ITimeoutService} */
	$timeout;

	/** @type {import('angular').IWindowService} */
	$window;

	/** @type {Knitiv.RootScope} */
	$rootScope;

	/** @type {import('angular').IIntervalService} */
	$interval;

	/** @type {import('angular').IFilterService} */
	$filter;

	/** @type {import('angular').IDocumentService} */
	$document;

	/** @type {import('angular').auto.IInjectorService} */
	$injector;

	/** @type {import('angular').route.IRouteParamsService} */
	$routeParams;

	/** @type {import('angular').ICompileService} */
	$compile;

	/** @type {import('angular').ILocationService} */
	$location;

	/** @type {any} */
	Notification;

	/** @type {import('angular').translate.ITranslateService} */
	$translate;

	/** @type {import('angular').ISCEService} */
	$sce;

	/** @type {Knitiv.APIV5} */
	api;

	/** @type {import('angular').ui.bootstrap.IModalService} */
	$uibModal;

	Bookmark;

	KTranslate;

	/** @type {Knitiv.FileDownloadServiceModel} */
	FileDownloadService;

	/** @type {import('~/components/search-bar/search.factory').default} */
	Search;

	/**
	 *
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		this.$injector = $injector;

		this.$q = $injector.get('$q');
		this.$timeout = $injector.get('$timeout');
		this.$window = $injector.get('$window');
		// @ts-expect-error
		this.$rootScope = $injector.get('$rootScope');
		this.$interval = $injector.get('$interval');
		this.$filter = $injector.get('$filter');
		this.$document = $injector.get('$document');
		this.$routeParams = $injector.get('$routeParams');
		this.$compile = $injector.get('$compile');
		this.$location = $injector.get('$location');
		this.Notification = $injector.get('Notification');
		this.$translate = $injector.get('$translate');
		this.$sce = $injector.get('$sce');
		this.Bookmark = $injector.get('Bookmark');
		this.KTranslate = $injector.get('KTranslate');
		this.$uibModal = $injector.get('$uibModal');
		this.Search = $injector.get('Search');
		this.FileDownloadService = $injector.get('FileDownloadService');

		this.api = APIV5.instance;
	}
}
